<template>
    <v-card elevation="4" tile>
        <div class="primary dark">
            <v-card-title class="white--text">Divisa</v-card-title>
        </div>
        <v-divider/>
        <v-card-text>
            <div>
                <v-card outlined tile>
                    <v-card-title>
                        <span class="text-center" style="width: 100%">
                            Divisa Por Defecto
                        </span>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <h2 v-if="divisaLoading">Cargando</h2>
                        <template v-else-if="divisaDefault">
                            <h2>{{ divisaDefault.name }}</h2>
                            <p class="ma-0">Code: <b>{{ divisaDefault.code }}</b> Symbol: <b>{{ divisaDefault.symbol }}</b></p>
                            <div v-if="divisaList.length">
                                <div class="text-overline">Tasas</div>
                                <div>
                                    <v-chip 
                                        v-for="(divisa, index) of divisaList" 
                                        :key="`divisa-default-rates-item-${index}-${divisa.id}`"
                                        :color="divisa.is_active ? 'primary' : 'secondary'"
                                        class="mr-2"
                                        label
                                        small
                                        >
                                        {{ divisa.code }} : {{ divisa.rate | currency(divisaDefault.code) }}
                                    </v-chip>
                                </div>
                            </div>
                        </template>
                        <h2 v-else>Error cargando</h2>
                    </v-card-text>
                </v-card>
            </div>
            <div>
                <template v-if="divisaListLoading">
                    <v-card outlined>
                        <v-card-text class="d-flex justify-center align-center">
                            Cargando...
                        </v-card-text>
                    </v-card>
                </template>
                <template v-else>
                    <template v-if="!divisaList.length">
                        <v-card outlined>
                            <v-card-text class="d-flex justify-center align-center">
                                Sin elementos que mostrar
                            </v-card-text>
                        </v-card>
                    </template>
                    <template v-else>
                        <v-tabs>
                            <v-tab v-for="(divisa, index) of divisaList" :key="`divisa-tab-${index}-${divisa.id}`">{{ divisa.name }}</v-tab>
                            <v-tab-item v-for="(divisa, index) of divisaList" :key="`divisa-tab-item-${index}-${divisa.id}`">
                                <v-card outlined tile>
                                    <v-card-title>
                                        {{ divisa.name }}
                                    </v-card-title>
                                    <v-card-text>
                                        <Rate :divisa="divisa" :divisaDefault="divisaDefault" @saved="getList()"/>
                                        <v-divider class="my-3" inset/>
                                        <RateList :divisa="divisa" :divisaDefault="divisaDefault"/>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs>
                    </template>
                </template>
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
import DivisaService from '@/services/general/DivisaService';

import Rate from '@components/entities/general/divisa/rate';
import RateList from '@components/entities/general/divisa/rate/list';

export default {
    components: {
        Rate,
        RateList
    },
    data: () => ({
        divisaListLoading: false,
        divisaList: [],
        divisaLoading: false,
        divisaDefault: null,
    }),
    methods: {
        getList: function () {
            this.divisaListLoading = true;
            this.divisaList = [];
            DivisaService
                .getList({is_default: false})
                .then(({ divisaList }) => {
                    this.divisaList = divisaList;
                })
                .finally(() => this.divisaListLoading = false);
        },
        get: function () {
            this.divisaDefaultLoading = true;
            DivisaService
                .getBy({is_default: true, is_active: true})
                .then(({ divisa }) => {
                    this.divisaDefault = divisa;
                })
                .finally(() => this.divisaDefaultLoading = false);
        },
    },
    mounted: function () {
        this.$store.dispatch('ui/layout/setTitle', 'Edición de Divisas');
        this.getList();
        this.get();
    }
}
</script>